<template>
  <k-page class="page-settings-foundations-categories">
    <the-settings-foundations-categories />
  </k-page>
</template>

<script>
/**
 * Component: page-settings-foundations-categories - Страница настроек категорий фондов
*
* @version 1.0.0
*/


// Components
import KPage from '@/components/KPage.vue';
import TheSettingsFoundationsCategories from '@/components/TheSettingsFoundationsCategories.vue';


export default {
  name: 'page-settings-foundations-categories',

  components: {
    KPage,
    TheSettingsFoundationsCategories,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.page-settings-foundations-categories {
  $this: &;
}
</style>
